export default [
    {
        path: '/sales/target',
        name: 'target',
        props: true,
        component: () => import('@/views/sales/target/index.vue'),
        meta: {
            pageTitle: 'Target',
            breadcrumb: [
                {
                text: 'Target',
                active: true,
                },
            ],
        },
    },
    {
        path: '/sales/target/add',
        name: 'create-target',
        component: () => import('@/views/sales/target/create.vue'),
        meta: {
            pageTitle: 'Create Target',
            breadcrumb: [
                {
                text: 'Target',
                to: { name: 'target' },
                },
                {
                text: 'Create Target',
                active: true,
                },
            ],
        },
    },
    {
        path: '/sales/target/:id',
        name: 'detail-target',
        props: true,
        component: () => import('@/views/sales/target/detail.vue'),
        meta: {
            pageTitle: 'Detail Target',
            breadcrumb: [
                {
                text: 'Target',
                to: { name: 'target' },
                },
                {
                text: 'Detail Target',
                active: true,
                },
            ],
        },
    },
]